import { Checkbox, notification } from 'antd';
import { useDispatch } from 'react-redux';
import { useUpsertStatusMutation } from 'services';
import apiInstance from 'services/api';

/**
 * "İlişkili madde yoktur" ve "İç Kontrol Yapıldı" checkbox'ları.
 * Tıklanır tıklanmaz API isteği atar ve optimistic update uygular.
 * @param {Object} props
 * @param {Object} props.data - Relation group overview detail verisi
 * @param {string} props.uid - URL'deki ilişki grubu kimliği (ör: "dia-1131")
 */
function DecisionCheckbox({ data, uid }) {
  const dispatch = useDispatch();
  const [upsertStatus] = useUpsertStatusMutation();

  const handleChange = async (field, checked) => {
    const patchResult = dispatch(
      apiInstance.util.updateQueryData('getRelationGroupOverviewDetail', { uid }, (draft) => {
        draft[field] = checked;
      }),
    );

    const { error } = await upsertStatus({
      body: {
        sourceId: data.originalId,
        sourceType: data.type,
        hasNoRelation: field === 'hasNoRelation' ? checked : data.hasNoRelation,
        hasChecked: field === 'hasChecked' ? checked : data.hasChecked,
      },
    });

    if (error) {
      patchResult.undo();
      notification.error({
        message: 'Durum Güncellenirken Bir Hata Oluştu',
        description: error.data?.message,
      });
    }
  };

  return (
    <div>
      <Checkbox
        checked={data?.hasNoRelation}
        onChange={(e) => handleChange('hasNoRelation', e.target.checked)}
      >
        İlişkili madde yoktur
      </Checkbox>
      <Checkbox
        checked={data?.hasChecked}
        onChange={(e) => handleChange('hasChecked', e.target.checked)}
      >
        İç Kontrol Yapıldı
      </Checkbox>
    </div>
  );
}

export default DecisionCheckbox;
